export const TEAM_TABS = ["About", "TEAMscan", "Team Personality"] as const;

export const SAMPLE_TEAM_IDS = [1104, 1105] as const;
